














import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class CircleProgress extends Vue {
  @Prop({ type: Number, default: 0 }) readonly percent!: number
  @Prop({ type: Number, default: 100 }) readonly width!: number
  @Prop({ type: String, default: '#51A275' }) readonly color!: string

  wholeStyle = {
    width: '0px',
    height: '0px',
    borderWidth: '0px'
  }

  leftStyle = {
    width: '0px',
    height: '0px',
    borderWidth: '0px',
    transform: '',
    borderLeftColor: '',
    borderBottomColor: ''
  }

  rightStyle = {
    width: '0px',
    height: '0px',
    borderWidth: '0px',
    transform: '',
    borderTopColor: '',
    borderRightColor: ''
  }

  coverStyle = {
    width: '0px',
    height: '0px'
  }

  mounted () {
    const [rightDeg, leftDeg] = this.calculateAngle()
    this.wholeStyle = {
      width: this.width + 'px',
      height: this.width + 'px',
      borderWidth: this.width / 4 + 'px'
    }
    this.leftStyle = {
      width: this.width + 'px',
      height: this.width + 'px',
      borderWidth: this.width / 4 + 'px',
      borderLeftColor: this.color,
      borderBottomColor: this.color,
      transform: 'rotate(' + leftDeg + 'deg)'
    }
    this.rightStyle = {
      width: this.width + 'px',
      height: this.width + 'px',
      borderWidth: this.width / 4 + 'px',
      borderRightColor: this.color,
      borderTopColor: this.color,
      transform: 'rotate(' + rightDeg + 'deg)'
    }
    this.coverStyle = {
      width: this.width / 2 + 'px',
      height: this.width + 'px'
    }
  }

  calculateAngle () {
    if (this.percent <= 50) {
      const deg = this.percent * 3.6 - 135
      return [deg, '-135']
    } else {
      const deg = (this.percent - 50) * 3.6 - 135
      return ['45', deg]
    }
  }
}
